import React from 'react';
import { Check } from 'lucide-react';
import { ProductMockupLarge } from './ProductMockupLarge';

const features = [
  'Structured option abstraction',
  'Automated window countdown tracking',
  'CAM cap and exclusion registry',
  'Portfolio-level filtering and reporting',
  'Status verification history with timestamps',
  'Building and tenant-level visibility',
];

export function SolutionSection(): JSX.Element {
  return (
    <section id='platform' className='py-24 md:py-32'>
      <div className='mx-auto max-w-6xl px-6'>
        <div className='mx-auto max-w-2xl text-center'>
          <h2
            className='text-3xl font-bold tracking-tight text-foreground md:text-4xl text-balance'
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            The Lease Monitoring Layer
          </h2>

          <p className='mt-6 text-base leading-relaxed text-muted-foreground text-pretty'>
            Strada extracts key lease terms and converts them into structured,
            monitorable data across your portfolio.
          </p>
        </div>

        <ul className='mx-auto mt-12 grid max-w-3xl gap-x-12 gap-y-4 md:grid-cols-2'>
          {features.map((feature) => (
            <li key={feature} className='flex items-start gap-3'>
              <div className='mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal/30'>
                <Check className='h-3 w-3 text-foreground' />
              </div>
              <span className='text-sm leading-relaxed text-muted-foreground'>
                {feature}
              </span>
            </li>
          ))}
        </ul>

        <div className='mt-16'>
          <ProductMockupLarge />
        </div>
      </div>
    </section>
  );
}
